import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


const squash = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]/g, "");

// First name, or "" when the stored name was only copied from the email address.
export function firstName(user) {
  const name = (user?.name || "").trim();
  if (!name || squash(name) === squash((user?.email || "").split("@")[0])) return "";
  return name.split(/\s+/)[0];
}
